var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.440633,
    y: 4.9504,
    width: 12.068,
    height: 11.5632,
    rx: 0.440633,
    stroke: "white",
    strokeWidth: 0.881266
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0982 0.954353C17.0982 0.715882 16.897 0.522563 16.6489 0.522563L12.6051 0.522563C12.357 0.522563 12.1558 0.715882 12.1558 0.954353C12.1558 1.19282 12.357 1.38614 12.6051 1.38614L16.1996 1.38614L16.1996 4.84046C16.1996 5.07893 16.4007 5.27225 16.6489 5.27225C16.897 5.27225 17.0982 5.07893 17.0982 4.84046L17.0982 0.954353ZM7.39941 9.84326L7.71712 10.1486L16.9666 1.25967L16.6489 0.954353L16.3312 0.649032L7.08171 9.53794L7.39941 9.84326Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/openIcon.279dadfb432606e340f32fc0e52c829e.svg";
export { ForwardRef as ReactComponent };